/**
 * URL schemes allowed as a redirect target. Anything else (javascript:, data:,
 * vbscript:, blob:, file:, ...) is rejected, remediating XSS attacks.
 */
const ALLOWED_PROTOCOLS = ["http:", "https:"];

/**
 * Check whether an externally provided URL is safe to navigate to.
 */
function isAllowedRedirectUrl(url: string): boolean {
  if (!url) {
    return false;
  }

  try {
    const { protocol } = new URL(url, window.location.origin);

    if (!ALLOWED_PROTOCOLS.includes(protocol)) {
      console.error(":::REDIRECT | isAllowedRedirectUrl():::blocked redirect to disallowed scheme:::", protocol);
      return false;
    }

    return true;
  } catch {
    console.error(":::REDIRECT | isAllowedRedirectUrl():::blocked malformed URL:::");
    return false;
  }
}

/**
 * Redirect the current window only when the URL uses an allowed scheme.
 */
export function redirectIfAllowed(url: string): void {
  if (isAllowedRedirectUrl(url)) {
    window.location.href = url;
  }
}

/**
 * Open a URL in a new browsing context only when it uses an allowed scheme.
 */
export function openUrlIfAllowed(url: string, target: string = "_blank"): Window | null {
  if (!isAllowedRedirectUrl(url)) {
    return null;
  }

  return window.open(url, target);
}
